// Evento para abrir el selector de ubicación desde cualquier pantalla
export const EVENTO_CAMBIAR_UBICACION = "blizu:cambiar-ubicacion";
export const abrirCambioUbicacion = () => window.dispatchEvent(new Event(EVENTO_CAMBIAR_UBICACION));
